import { h } from '@stencil/core';
import { parseCommonURLToRouterParts } from '@pes-ui/utils';
import PesRoute from '../../pes-router/pes-route';
import { isAppRoutingEnabled, navigateWithRouter } from '../../pes-router/utils';
export class ProductCardId {
  constructor() {
    this.onClickHandler = (event) => {
      var _a;
      (_a = this.onRecentlyViewedItemClick) === null || _a === void 0 ? void 0 : _a.call(this, {
        event,
        id: this.name,
        name: this.name,
        url: this.productUrl,
      });
      if (isAppRoutingEnabled()) {
        navigateWithRouter(this.route, event.currentTarget);
      }
    };
    this.name = undefined;
    this.productUrl = undefined;
    this.description = undefined;
    this.imageUrl = undefined;
    this.imageTitle = undefined;
    this.onRecentlyViewedItemClick = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  componentWillLoad() {
    if (isAppRoutingEnabled()) {
      const { pageType, pageId } = parseCommonURLToRouterParts(this.productUrl);
      this.route = new PesRoute({ page: pageType, pageId });
      this.productUrl = this.route.url;
    }
  }
  render() {
    return (h("a", { href: this.productUrl, class: "card", onClick: this.onClickHandler }, h("pes-lazy-img", { class: "card__img", src: this.imageUrl, alt: this.imageTitle }), h("section", { class: "card__info" }, h("span", { class: "card__name" }, this.name), h("p", { class: "card__description" }, this.description ? h("pes-ellipsis", { maxHeight: "50px", content: this.description }) : ''))));
  }
  static get is() { return "pes-product-card-id"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["product-card-id.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["product-card-id.css"]
    };
  }
  static get properties() {
    return {
      "name": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Product commercial reference"
        },
        "attribute": "name",
        "reflect": false
      },
      "productUrl": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Url of product description page"
        },
        "attribute": "product-url",
        "reflect": false
      },
      "description": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Product description"
        },
        "attribute": "description",
        "reflect": false
      },
      "imageUrl": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Image url of a product"
        },
        "attribute": "image-url",
        "reflect": false
      },
      "imageTitle": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Image title of a product"
        },
        "attribute": "image-title",
        "reflect": false
      },
      "onRecentlyViewedItemClick": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "(params: OnRecentlyViewedItemClickParams) => void",
          "resolved": "(params: OnRecentlyViewedItemClickParams) => void",
          "references": {
            "OnRecentlyViewedItemClickParams": {
              "location": "import",
              "path": "../types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Callback for saving breadcrumbs in indexDB"
        }
      }
    };
  }
  static get elementRef() { return "el"; }
}
